import React from "react";

export function Footer(): React.ReactElement {
  return (
    <footer className="w-full border-t-2 border-gray-400 bg-gray-800 text-gray-300">
      <div className="mx-auto w-full max-w-6xl px-6 py-6">
        <p className="text-center">© 2025 Pedro&apos;s Portfolio. All rights reserved.</p>
      </div>
    </footer>
  );
}
